'use client';

import * as Popover from '@radix-ui/react-popover';
import {SettingsIcon} from 'lucide-react';

import {Button} from '@/modules/foundation/components/button';

import type {ProductDescription} from './description';
import ProductDescriptionList from './ProductDescriptionList';

export default function ProductConfigPopover({
	description,
}: {
	description?: ProductDescription | null;
}) {
	if (!description || Object.entries(description).length === 0) {
		return null;
	}

	return (
		<div className="text-right">
			<Popover.Root>
				<Popover.Trigger asChild>
					<Button
						variant="tertiary"
						className="h-8 p-1 lg:h-8 lg:p-1"
						aria-label="Vis konfigurasjon"
					>
						<SettingsIcon size={20} className="inline" />
					</Button>
				</Popover.Trigger>
				<Popover.Portal>
					<Popover.Content
						className="PopoverContent flex flex-col gap-2 rounded bg-black p-4 text-sm"
						align="end"
					>
						<div className="border-b pb-1 text-sm shadow-lg">
							<strong>Konfigurasjon</strong>
						</div>
						<ProductDescriptionList description={description} />
						<Popover.Arrow className="PopoverArrow" />
					</Popover.Content>
				</Popover.Portal>
			</Popover.Root>
		</div>
	);
}
